module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("ClaimTransfer", "Transfer subscription") ))==null?'':__t)+
'</legend><p>'+
((__t=(i18n.tc("ClaimTransfer", "Would you like to transfer %s to your account?").format( alias) ))==null?'':__t)+
'</p><div class="content"><dl><dt>'+
((__t=( i18n.tc("ClaimTransfer", "Current owner:") ))==null?'':__t)+
'</dt><dd>'+
((__t=( ownerName ))==null?'':__t)+
'</dd><dt>'+
((__t=( i18n.tc("ClaimTransfer", "Subscription:") ))==null?'':__t)+
'</dt><dd>'+
((__t=( subscriptionName ))==null?'':__t)+
'</dd> ';
 if ( renewable ) { 
__p+=' <dt>'+
((__t=( i18n.tc("ClaimTransfer", "Yearly price:") ))==null?'':__t)+
'</dt><dd>'+
((__t=( transientFormatYearlyPrice ))==null?'':__t)+
' '+
((__t=( i18n.tc("ClaimTransfer", "(tax incl.)") ))==null?'':__t)+
'</dd> ';
 } 
__p+=' </dl></div> ';
 if ( renewable ) { 
__p+=' <p><em><span class="success">'+
((__t=( i18n.tc("ClaimTransfer", "This subscription is set to renew on %s.").format( renewalDate) ))==null?'':__t)+
'</span></em></p> ';
 } else { 
__p+=' <p><em><span class="warning">'+
((__t=( i18n.tc("ClaimTransfer", "This subscription will end on %s.").format(renewalDate) ))==null?'':__t)+
'</span></em></p> ';
 } 
__p+=' </fieldset><fieldset class="button-wrap"><button data-click="transfer-cancel">'+
((__t=( i18n.tc("ClaimTransfer", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="transfer-submit">'+
((__t=( i18n.tc("ClaimTransfer", "Next") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
